import axios from '@/libs/api.request'
import {
    localToken,
    cache,
    toolFunc
} from '@/libs/func';
const permission = {
    loginTest2: () => {
        return axios.get({
            url: '/User/login'
        })
    },
    // 模拟登陆
    loginTest() {
        return new Promise((resolve, reject) => {
            let data = {
                "token": {
                    "status": true,
                    "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoi5Yaw5bCB5aSV6ZizIiwidWlkIjoiODlmNjkxNzQtYTZiMS00Y2Q4LWM1YWYtMDhkNzE5NGUwY2M0IiwidG5pZCI6IjAwMDAwMDAwLTAwMDAtMDAwMC0wMDAwLTAwMDAwMDAwMDAwMCIsImJpbmQiOiIxIiwiZXhwIjoxNTY1MDc3MzM4LCJuYmYiOjE1NjUwNTkzMzgsImlzcyI6ImFjaGluYXl1biIsImF1ZCI6ImFjaGluYSJ9.xQl7Nj4I4HR7nZTPB96VlrPwCujFgL5ahk2iUVlg_aY",
                    "expires_in": 18000,
                    "token_type": "Bearer"
                }
            };
            let token =
                data.token.token_type + " " + data.token.access_token || ""; //token值
            let expires = data.token.expires_in || 7200;
            localToken.set(token, expires); //存储token（已经登录的token）
            resolve(data);
        });
    },

}
export default permission


// WEBPACK FOOTER //
// ./src/api/api-permission.js